import Identifiable from 'interfaces/Identifiable';

export interface BatchJob extends Identifiable {
  id?: number,
  jobId?: string,
  eventTime: Date,
  createdAt: Date,
  jobStatus: JobStatus,
  jobLog: string[]
}

export enum JobStatus {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Error = 'Error',
  Success = 'Success'
}
